module.exports = __webpack_public_path__ + "img/gar.9eade8b.svg";